import React from "react";
import { Chapter } from "../types/Chapter";

interface GetChapterProps {
  chapterNumber: number;
  newChapterLoaded: (response: Chapter) => void;
}

const z3 = (n: number) => String(n).padStart(3, "0");

function GetChapter({ chapterNumber, newChapterLoaded }: GetChapterProps): null {
  React.useEffect(() => {
    // Normalize to valid range (mirrors original logic)
    const ch = chapterNumber <= 114 ? chapterNumber : 1;
    const url = `/translation/quran-${z3(ch)}.json`;

    // Abort fetch if unmounted or chapter changes mid-flight
    const ctrl = new AbortController();

    (async () => {
      try {
        const res = await fetch(url, {
          signal: ctrl.signal,
          // These JSON files are static; let the browser use its HTTP cache
          cache: "force-cache",
        });
        if (!res.ok) {
          throw new Error(`HTTP ${res.status} while fetching ${url}`);
        }
        const data = (await res.json()) as Chapter;
        newChapterLoaded(data);
      } catch (err: any) {
        if (err?.name === "AbortError") return; // expected on unmount/change
        // keep quiet in prod; you can wire this to your logger if desired
        console.warn("error loading chapter", err);
      }
    })();

    return () => {
      ctrl.abort();
    };
  }, [chapterNumber, newChapterLoaded]); // re-run only when the target chapter changes

  return null;
}

export default GetChapter;
